import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import VuetifyConfirm from 'vuetify-confirm';
import auroraModule from '@codehq/aurora-app-core/src/plugins/auroraModule';
import ImageUpload from '@codehq/aurora-app-core/src/components/ImageUpload.vue';
import LocaleSwitcher from '@codehq/aurora-app-core/src/components/LocaleSwitcher.vue';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import VueOwinAuth from '@codehq/vue-owin-auth/src/vueOwinAuth';
import { o } from 'odata';
import { mapState } from 'vuex';
import VueExcelXlsx from 'vue-excel-xlsx';
import VueSignaturePad from 'vue-signature-pad';
import VueMask from 'v-mask';
import TimeField from './modules/processing/components/TimeField.vue';
import DateTimeField from './modules/processing/components/DateTimeField.vue';
import DateField from './modules/processing/components/DateField.vue';
import BoolField from './modules/processing/components/BoolField.vue';

import App from './App.vue';
import authMixin from './mixins/auth-mixin';
import vuetify from './plugins/vuetify';
import store from './store';
import { router, routes } from './router';
import { i18n, messages } from './i18n';

Vue.use(VueSignaturePad);

Vue.use(VueAxios, axios);

Vue.use(VueMask);
Vue.use(DateField);
Vue.use(DateTimeField);
Vue.use(TimeField);
Vue.use(BoolField.name, BoolField);

Vue.use(VueOwinAuth, {
  url: process.env.VUE_APP_APIURL,
  client_id: process.env.VUE_APP_CLIENT_ID,
  client_secret: process.env.VUE_APP_CLIENT_SECRET,
});

Vue.use(VuetifyConfirm, { vuetify });

Vue.config.productionTip = false;

// register aurora components and plugin
Vue.component(LocaleSwitcher.name, LocaleSwitcher);
Vue.component(TableBasicButtons.name, TableBasicButtons);
Vue.component(ImageUpload.name, ImageUpload);
Vue.use(VueExcelXlsx);

store.$http = axios;
Vue.use(auroraModule, {
  baseUrl: process.env.VUE_APP_APIURL,
  store,
});

// dayjs
dayjs.extend(relativeTime);

// format
Vue.mixin({
  methods: {
    formatDateTime(dt) {
      return dayjs(dt).format('YYYY-MM-DD HH:mm');
    },
    formatDate(dt) {
      return dayjs(dt).format('YYYY-MM-DD');
    },
    formatFromNow(dt) {
      return dayjs(dt).fromNow();
    },
    formatNumber(num) {
      return (num ?? 0).toFixed(3);
    },
  },
});

// Setup API
axios.defaults.baseURL = process.env.VUE_APP_APIURL;

o(process.env.VUE_APP_APIURL);

Vue.config.devTools = true;

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
  mixins: [authMixin],
  computed: {
    ...mapState('app', ['token', 'token_expires', 'refresh_token']),
  },

  i18n,
  mounted() {
    this.$log.debug('Locales:');
    this.$log.debug(messages);
    this.$log.debug('Routes:');
    this.$log.debug(routes);
  },
  methods: {
    getRemainingExpires(date) {
      const date1 = new Date(date);
      const date2 = new Date();
      return Math.abs(date2 - date1);
    },
    async refreshToken() {
      this.$log.info('refreshing auth token');
      // refresh token expired
      const result = await this.$auth.refreshToken(this.refresh_token);
      this.$root.$emit('auth:token', result.data);
      this.$log.info('refreshed auth token');
    },
  },
}).$mount('#app');
